const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "");

export const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_BASE_URL || "",
);
export const APP_WS_URL = process.env.REACT_APP_WS_URL;
export const APP_SCAN_WS_TOKEN = process.env.REACT_APP_SCAN_WS_TOKEN;
export const APP_LOGIN_URL =
  process.env.REACT_APP_LOGIN_URL || process.env.REACT_APP_LOGIN_BASE_URL || "";

export const buildApiUrl = (path = "") => {
  const normalizedPath = String(path).replace(/^\/+/, "");
  if (!normalizedPath) return API_BASE_URL;
  if (/^https?:\/\//i.test(normalizedPath)) return normalizedPath;
  return `${API_BASE_URL}/${normalizedPath}`;
};
